export const TagTypes = {
  TAG_TYPE_CUSTOM: 0,
  TAG_TYPE_AUTOMATIC: 1,
};

export enum TagType {
  Custom = TagTypes.TAG_TYPE_CUSTOM,
  Automatic = TagTypes.TAG_TYPE_AUTOMATIC,
}

export const TagTypeToName = {
  [TagTypes.TAG_TYPE_CUSTOM]: 'Custom',
  [TagTypes.TAG_TYPE_AUTOMATIC]: 'Automatic',
};

export const tagTypeFilterValues = Object.entries(TagTypeToName).map(([value, label]) => ({
  value: Number(value),
  label,
}));
